import { Component, OnInit } from '@angular/core';

import { ManagePaymentsComponent } from '../manage-payments/manage-payments.component';
import { WaysToPayComponent } from '../ways-to-pay/ways-to-pay.component';
import { BillingComponent } from '../billing/billing.component';

@Component({
  selector: 'app-options-container',
  templateUrl: './options-container.component.html',
  styleUrls: ['./options-container.component.css']
})
export class OptionsContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/options-container/options-container.component.ts